import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d8b1156")

_pushScopeId("data-v-6d8b1156")
const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = { class: "row p-2" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = /*#__PURE__*/_createVNode("small", { class: "tituloInfoDetalle" }, "Metropolitana", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Sucursales", -1)
const _hoisted_6 = { class: "row col-md-8" }
const _hoisted_7 = { class: "col-md-8" }
const _hoisted_8 = { class: "contenidoInfoDetalle" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "importeInfoDetalle" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = /*#__PURE__*/_createVNode("small", { class: "tituloInfoDetalle" }, "Interior de la República", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Sucursales", -1)
const _hoisted_14 = { class: "row col-md-8" }
const _hoisted_15 = { class: "col-md-8" }
const _hoisted_16 = { class: "contenidoInfoDetalle" }
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "importeInfoDetalle" }
const _hoisted_19 = { class: "col-12 mt-2" }
const _hoisted_20 = { class: "subtotal-detalle" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "subtotal-detalle-label" }, "Suma Sucursales", -1)
const _hoisted_22 = { class: "subtotal-detalle-monto" }
const _hoisted_23 = { class: "row p-2" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = /*#__PURE__*/_createVNode("small", { class: "tituloInfoDetalle" }, "Áreas", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Corporativo", -1)
const _hoisted_27 = { class: "row col-md-12" }
const _hoisted_28 = { class: "col-md-8" }
const _hoisted_29 = { class: "contenidoInfoDetalle" }
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "importeInfoDetalle" }
const _hoisted_32 = { class: "mt-2" }
const _hoisted_33 = { class: "subtotal-detalle" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "subtotal-detalle-label" }, "Suma Áreas", -1)
const _hoisted_35 = { class: "subtotal-detalle-monto" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = /*#__PURE__*/_createVNode("small", { class: "tituloInfoDetalle" }, "Grupos", -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "HirCasa", -1)
const _hoisted_39 = { class: "row col-md-12" }
const _hoisted_40 = { class: "col-md-8" }
const _hoisted_41 = { class: "contenidoInfoDetalle" }
const _hoisted_42 = { class: "col-md-4" }
const _hoisted_43 = { class: "importeInfoDetalle" }
const _hoisted_44 = { class: "mt-2" }
const _hoisted_45 = { class: "subtotal-detalle" }
const _hoisted_46 = /*#__PURE__*/_createVNode("span", { class: "subtotal-detalle-label" }, "Suma Grupos", -1)
const _hoisted_47 = { class: "subtotal-detalle-monto" }
const _hoisted_48 = { class: "row p-2" }
const _hoisted_49 = { class: "col-12" }
const _hoisted_50 = { class: "total-detalle" }
const _hoisted_51 = /*#__PURE__*/_createVNode("span", { class: "total-detalle-label" }, "Total a pagar sin I.V.A", -1)
const _hoisted_52 = { class: "total-detalle-monto" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.MetroElegidas, (metroelegida) => {
          return (_openBlock(), _createBlock("div", {
            class: "row",
            key: metroelegida.clave
          }, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("small", _hoisted_8, _toDisplayString(metroelegida.clave) + " - " + _toDisplayString(metroelegida.nombre), 1)
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("small", _hoisted_10, "$ " + _toDisplayString(_ctx.formatearImporte(metroelegida.monto)), 1)
              ])
            ])
          ]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _hoisted_13,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ForaneasElegidas, (foraneaelegida) => {
          return (_openBlock(), _createBlock("div", {
            class: "row",
            key: foraneaelegida.clave
          }, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("small", _hoisted_16, _toDisplayString(foraneaelegida.clave) + " - " + _toDisplayString(foraneaelegida.nombre), 1)
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode("small", _hoisted_18, "$ " + _toDisplayString(_ctx.formatearImporte(foraneaelegida.monto)), 1)
              ])
            ])
          ]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_19, [
        _createVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode("span", _hoisted_22, "$ " + _toDisplayString(_ctx.formatearImporte(_ctx.sumaSucursales)), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_23, [
      _createVNode("div", _hoisted_24, [
        _hoisted_25,
        _hoisted_26,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.AreasElegidas, (areaelegida) => {
          return (_openBlock(), _createBlock("div", {
            class: "row",
            key: areaelegida.clave
          }, [
            _createVNode("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, [
                _createVNode("small", _hoisted_29, _toDisplayString(areaelegida.clave) + " - " + _toDisplayString(areaelegida.nombre), 1)
              ]),
              _createVNode("div", _hoisted_30, [
                _createVNode("small", _hoisted_31, "$ " + _toDisplayString(_ctx.formatearImporte(areaelegida.monto)), 1)
              ])
            ])
          ]))
        }), 128)),
        _createVNode("div", _hoisted_32, [
          _createVNode("div", _hoisted_33, [
            _hoisted_34,
            _createVNode("span", _hoisted_35, "$ " + _toDisplayString(_ctx.formatearImporte(_ctx.sumaAreas)), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_36, [
        _hoisted_37,
        _hoisted_38,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.GruposElegidos, (grupoelegido) => {
          return (_openBlock(), _createBlock("div", {
            class: "row",
            key: grupoelegido.clave
          }, [
            _createVNode("div", _hoisted_39, [
              _createVNode("div", _hoisted_40, [
                _createVNode("small", _hoisted_41, _toDisplayString(grupoelegido.clave) + " - " + _toDisplayString(grupoelegido.nombre), 1)
              ]),
              _createVNode("div", _hoisted_42, [
                _createVNode("small", _hoisted_43, "$ " + _toDisplayString(_ctx.formatearImporte(grupoelegido.monto)), 1)
              ])
            ])
          ]))
        }), 128)),
        _createVNode("div", _hoisted_44, [
          _createVNode("div", _hoisted_45, [
            _hoisted_46,
            _createVNode("span", _hoisted_47, "$ " + _toDisplayString(_ctx.formatearImporte(_ctx.sumaGrupos)), 1)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_48, [
      _createVNode("div", _hoisted_49, [
        _createVNode("div", _hoisted_50, [
          _hoisted_51,
          _createVNode("span", _hoisted_52, "$ " + _toDisplayString(_ctx.formatearImporte(_ctx.sumaSucursales + _ctx.sumaAreas + _ctx.sumaGrupos)), 1)
        ])
      ])
    ])
  ]))
})